import React, { useState, useEffect } from 'react';
import { Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Breadcrumb from '../../../components/Breadcrumb';
import ColorCard from '../components/ColorCard';

const NaturalColorsDisplay = () => {
  const [colorImages, setColorImages] = useState([]);

  useEffect(() => {
    const availableColorImages = [
      { id: 1, name: 'Color 1', image: '/images/colors/color1.jpeg' },
      { id: 2, name: 'Color 2', image: '/images/colors/color2.jpeg' },
      { id: 3, name: 'Color 3', image: '/images/colors/color3.jpeg' },
      { id: 4, name: 'Color 4', image: '/images/colors/color4.jpeg' },
      { id: 5, name: 'Color 5', image: '/images/colors/color5.jpeg' },
      { id: 6, name: 'Color 6', image: '/images/colors/color6.jpeg' },
      { id: 7, name: 'Color 7', image: '/images/colors/color7.jpeg' },
      { id: 8, name: 'Color 8', image: '/images/colors/color8.jpeg' },
      { id: 9, name: 'Color 9', image: '/images/colors/color9.jpeg' },
      { id: 10, name: 'Color 10', image: '/images/colors/color10.jpeg' },
      { id: 11, name: 'Color 11', image: '/images/colors/color11.jpeg' },
      { id: 12, name: 'Color 12', image: '/images/colors/color12.jpeg' },
      { id: 13, name: 'Color 13', image: '/images/colors/color13.jpeg' },
      { id: 14, name: 'Color 14', image: '/images/colors/color14.jpeg' },
    ];

    setColorImages(availableColorImages);
  }, []);

  return (
    <Row className="px-2">
      <Breadcrumb
        navigation={[
          { link: '/cake/home', title: 'Categories' },
          { link: '#', title: 'Natural Colors' },
        ]}
      />
      <div>
        <Link to={'/cake/home'} className="text-decoration-none">
          <button className="btn app-btn-primary mb-3 me-5">&larr; Back</button>
        </Link>
      </div>
      {colorImages.map((color) => (
        <Col xxl={2} xl={2} lg={3} md={4} sm={6} xs={6} key={color.id} className="mb-3 px-1">
          <ColorCard
            image={`${process.env.PUBLIC_URL}${color.image}`}
            alt={color.name}
            onClick={() => console.log(`Selected ${color.name}`)}
          />
        </Col>
      ))}
    </Row>
  );
};

export default NaturalColorsDisplay;